import React from 'react'
import GlobalSearchContainer from 'modules/react/global-search/GlobalSearchContainer'
import GlobalSearchContent from 'modules/react/global-search/GlobalSearchContent'

export default function GlobalSearch (props) {

  return (
    <GlobalSearchContainer {...props}>
      <GlobalSearchContent/>
    </GlobalSearchContainer>
  )
}